import Backbone from "backboneAdapter";
import _ from "underscore";
import i18n from "l10n";
import "passwordStrength";
import "parallax";
import Handlebars from "handlebars";
import Template from "templates/password.reset.hbs";
import 'zxcvbn';

let template = Handlebars.compile(Template);

var PassRecoverView = Backbone.View.extend({
    el: '#page-main-content',
    events: {
        "keydown .input-control": "keypress",
        "keyup .input-control": "keypress",
        "click #submit-btn": "reset",
        "click .togglePasswordType": "togglePassWordViewable"
    },
    initialize: function (options) {
        var self = this;
        this.req_token = options.resetToken;
        this.render();

        const passwordLevelLabel = "";

        this.$('[data-i18n]').i18n();
        $('#passInput').pwstrength({
            i18n: i18n,
            ui: {
                verdicts: [
                    i18n.t("veryWeak", {label: passwordLevelLabel}),
                    i18n.t("weak", {label: passwordLevelLabel}),
                    i18n.t("normal", {label: passwordLevelLabel}),
                    i18n.t("medium", {label: passwordLevelLabel}),
                    i18n.t("strong", {label: passwordLevelLabel}),
                    i18n.t("veryStrong", {label: passwordLevelLabel})
                ],
                colorClasses: ["danger", "danger", "danger", "warning", "success", "success"]
            },
            common: {
                zxcvbn: true,
                onKeyUp: function (evt, data) {
                    var strongPass = data.verdictLevel > 3;
                    _.bind(self.checkPassword, self)(strongPass);
                }
            }
        });
        console.info('Initializing Password Recover View');
    },
    render(){
        this.$el.html(template);
    },
    async reset(event) {
        event.preventDefault(); // Don't let this button submit the form
        $('.alert-error').hide(); // Hide any errors on a new submit
        var url = '/CampaignCloud/PassReset/Reset';
        console.info('Change password...');
        var formValues = {
            req_token: this.req_token,
            password: $('#passInput').val()
        };

        console.info(formValues);
        try {
            const passResetResponse = await $.ajaxDefaultQ({
                url: url,
                type: 'POST',
                dataType: "json",
                data: formValues
            });
            console.info(passResetResponse);
            if (passResetResponse.status === "success") {
                window.open('Login.htm', '_self');
            } else if (passResetResponse.tokenUsed === "true" || passResetResponse.date === "passed") {
                $("#error-message").text(i18n.t("passwordreset.expiredrequest"));
            }
            else {
                $("#error-message").text(i18n.t("passwordreset.expiredrequest"));
            }

        } catch (response) {
            if (response.status === 401) {
                $("#error-message").text(i18n.t("passwordreset.internalerror"));
                // window.open('Login.htm','_self');
            }
        }
    },
    keypress: function (e) {

        if($("#submit-btn").val() && $("#submit-btn").val().trim().length == 0) {
            $("#submit-btn").prop("disabled", "disabled");
            return;
        }

        var key = e.which;
        if (key === 13 && e.type == "keydown") {
            $('input[id=submit-btn]').click();
            return false;
        }
    },
    checkPassword: function (strongPass) {
        var $passInput = $('#passInput');
        var password = $passInput.val();

        if (!password.length) {
            $passInput.removeClass('valid-input');
            $passInput.addClass('required-input');
        } else if (!strongPass) {
            $passInput.removeClass('invalid-input');
            $passInput.removeClass('valid-input');
            $passInput.removeClass('confirm-failure-input-borders');
            $passInput.addClass('required-input');
            $('#submit-btn').attr('disabled', true);
        } else {
            $passInput.removeClass('required-input');
            $passInput.addClass('valid-input');
            $("#submit-btn").removeAttr("disabled");
        }
    },
    togglePassWordViewable: function (e) {
        var $currentTarget = $(e.currentTarget);
        var $passInput = $("#" + $currentTarget.data("id"));
        if ($passInput.attr("type") === "password") {
            $passInput.attr("type", "text");
            $($currentTarget.find("span")).text(i18n.t("hide"));
        } else {
            $passInput.attr("type", "password");
            $($currentTarget.find("span")).text(i18n.t("show"));
        }
        e.preventDefault();
    }
});

export {PassRecoverView as default};